import React from 'react'
import classNames from 'classnames'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import RadioButton from 'src/components/Elements/RadioButton'

const PartnerFollowUpQuestion = ({ radioValue, setRadioValue, session }) => {
  const radioOptions = [
    { id: 1, value: true, name: 'Yes' },
    { id: 2, value: false, name: 'No' }
  ]

  const fumQuestionText = session?.session_type_key?.startsWith('session_type_gartner_')
    ? 'Want to learn more about how Gartner insights and experts can help you achieve your critical business priorities?'
    : 'Would you like to continue the conversation with the speaker(s) from this session?'

  return (
    <>
      <div className={classNames(generalStyles.mt30, generalStyles.mb20)}>
        <span className={fontStyles.psmallboldlsin08blackgraphik15pt}>
          {fumQuestionText}
        </span>
      </div>
      <div
        className={classNames(generalStyles.flexColumn, generalStyles.gap10)}
      >
        {radioOptions?.map((opt) => (
          <RadioButton 
            key={`radio-cmpt-${opt.id}`}
            id={opt.id}
            name={opt.name}
            selected={radioValue === opt.name}
            onClick={setRadioValue}
          />
        ))}
      </div>
    </>
  )
}

export default PartnerFollowUpQuestion
